import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { useActiveSectionValue } from '@/shared/atoms/active-section';
import { useActiveSectionSetState } from '@/shared/atoms/active-section';
import { useSetPageTransitionState } from '@/shared/atoms/page-transition';
import { AppNavigation } from '@/shared/lib/types';
import Link from '../Link';

type Props = React.HTMLAttributes<HTMLElement> & {
    navigation: AppNavigation;
};

function NavigationSections({ navigation, ...props }: Props) {
    const activeSection = useActiveSectionValue();
    const setLeaveTransition = useSetPageTransitionState();
    const setActiveSection = useActiveSectionSetState();
    const router = useRouter();
    const { asPath } = router;
    const navItemRefs = useRef<Record<string, HTMLAnchorElement | null>>({});

    const [isSmooth, setIsSmooth] = useState(false);

    useEffect(() => {
        if (activeSection !== null && navItemRefs.current[activeSection]) {
            const element = navItemRefs.current[activeSection];
            if (element) {
                element.scrollIntoView({
                    behavior: isSmooth ? 'smooth' : 'auto',
                    block: 'nearest',
                    inline: 'center',
                });
            }
        }
        setIsSmooth(true);
    }, [activeSection]);

    useEffect(() => {
        if (asPath) {
            const sectionIndex = navigation.findIndex((nav) => asPath === nav.href);

            if (sectionIndex !== -1) {
                setActiveSection(sectionIndex);
            } else {
                setActiveSection(0);
            }
        }
    }, [asPath, navigation, setActiveSection]);

    return (
        <div {...props} className={classNames('navigation-wrapper', props.className)}>
            <div className="navigation-pages__list text-l">
                {navigation.map((navItem) => (
                    <Link
                        href={navItem.href}
                        key={navItem.id}
                        className={classNames('navigation-pages__item', {
                            'is-active': activeSection === navItem.id,
                        })}
                        ref={(el) => {
                            if (el) {
                                navItemRefs.current[navItem.id] = el;
                            }
                        }}
                        onClick={() => {
                            setLeaveTransition({
                                mode: 'wait',
                                name: 'leaveMenu',
                            });
                        }}
                    >
                        {navItem.title}
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default NavigationSections;
